import {SfCallbackParams} from '../models/salesforce-orgs.interface';

export function sfCallbackParser(queryParams: SfCallbackParams): SfCallbackParams {
  const code = queryParams['code'];
  const stateParams = queryParams['state'].split(',');
  const paramsForParse: (keyof SfCallbackParams)[] = [
    'teamIndex',
    'teamId',
    'connectOrg',
    'implementationId',
    'isSandbox',
    'orgId',
    'type',
    'reconnectOrg',
    'startSync',
    'refModelId',
    'manualSyncOnlyEnabled',
    'isNewImplementation'
  ];

  const parsedValues: Partial<Record<keyof SfCallbackParams, string>> = {code};

  paramsForParse.forEach(queryParameter => {
    const paramString = stateParams.find((param: string) => param.startsWith(queryParameter + ':'));

    if (paramString) {
      const value = paramString.replace(`${queryParameter}:`, '');

      parsedValues[queryParameter] = value;
    }
  });

  return parsedValues as SfCallbackParams;
}
